import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import useRevokeExchange from '../../../hooks/nft/useRevokeExchange'
import { stopPropagation } from '../../../utils/func'

import { ButtonConfirmed } from '../../Button'
import { AutoRow } from '../../Row'
import Loader from '../../Loader'

const activeClassName = 'ACTIVENAV'
const Button = styled(ButtonConfirmed).attrs({
  activeClassName
})`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
  &.${activeClassName} {
    background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
    animation:scaleMove 2s linear	2s infinite;
    -webkit-animation:scaleMove 2s linear	2s infinite;
    transform: scale(1);
  @keyframes scaleMove
  {
    10% {
      transform: scale(1.2)
    }
    20% {
      transform: scale(1)
    }
    100% {
      transform: scale(1)
    }
  }
  }
`

export default function RevokeBtn ({artwork, marketType}: {artwork: any, marketType: string}) {
  // Revoke
  const { onRevokeExchange } = useRevokeExchange(artwork.tokenId, marketType)
  const [requestedRevoke, setRequestedRevoke] = useState(false)
  const handleRevoke = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedRevoke(true)
      const txHash = await onRevokeExchange()
      if (!txHash) {
        setRequestedRevoke(false)
      } else {
        // reset allowanceSell
        // setResetApproval(true)
        setTimeout(() => {
          setRequestedRevoke(false)
          // setResetApproval(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onRevokeExchange])

  return (
    <Button
      disabled={requestedRevoke}
      onClick={handleRevoke}
      altDisabledStyle={requestedRevoke}
      className={artwork.level !== 'v3' ? activeClassName : ''}
    >
      { 
        requestedRevoke ? (
          <AutoRow gap="6px" justify="center">
            Revoking <Loader stroke="white" />
          </AutoRow>
        ) : (
          'Revoke'
        )
      }
    </Button>
  )
}